import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useState } from 'react';
import { SelectMultiple, LoadingTip } from 'tea-component';



import { renderImgText } from '../TeaSelector/MultipleSelector';
import useDebounce from '@intelligence/components/GenreSelectMiddleware/Supports/_hooks/useDebounce';
import { useIntl } from 'umi';

const MetricsDataSourceAll = (props, ref: React.Ref<any>): React.ReactElement => {
  const {
    onConfirm,
  } = props;

  // console.log(props)
  const { formatMessage } = useIntl();

  // 搜索关键字
  const [keywords, setKeywords] = useState('');
  // 已选择公司列表数据(不区分非搜索模式、搜索模式)
  const [selected, setSelected] = useState(dataSourceAll.map((item) => item?.value))

  const [searchList, setSearchList] = useState<string[]>([]);

  const [isAll, setIsAll] = useState(true)

  const renderOptions = () => dataSourceAll?.map((item, idx) => ({
    value: item?.value,
    text: item?.img ? (renderImgText(item?.text, item?.img)
    ) : item?.text,
    buttonText: renderImgText(item?.text, item?.img),
  }));

  const handleChange = useCallback((value: string[]) => {
    // console.log("CHANGE")
    let payload = value;

    setSelected(value);

    if (!keywords) {
      payload = !value?.length || value?.length === dataSourceAll?.length ? [] : value;
    }

    if (keywords) {
      let isAll = true;

      searchList?.forEach((item) => {
        if (!value?.includes(item)) {
          isAll = false;
          // console.log("FALSE", item)
        }
      })

      setIsAll(isAll)
    } else {
      if (value?.length === dataSourceAll?.length) {
        setIsAll(true);
      } else {
        setIsAll(false)
      }
    }

    onConfirm instanceof Function && onConfirm(payload);

    // console.log(payload)
  }, [keywords, onConfirm]);

  // console.log("SEARCHLIST", searchList)

  const buttonLabel = useMemo(() => {
    const selectedCount = selected?.length || 0;
    const dataSourceCount = dataSourceAll?.length || 0;
    let result = '';
    if (!selectedCount || selectedCount === dataSourceCount) { // 没选择公司 或者 全选公司(包含 非搜索状态 和 搜索状态)
      result = formatMessage({ id: 'dbi_all' });
    } else if (selectedCount < 3) { // 选择公司数量小于3个
      result = selected.join(', ');
    } else { // 选择公司数量 大于 3 且 小于 全部公司(区分 非搜索状态 和 搜索状态)
      result = String(selectedCount);
    }
    return result
  }, [selected]);

  const handleReset = useCallback(() => {
    setKeywords('');
    setSelected(dataSourceAll.map((item) => item?.value))
    onConfirm instanceof Function && onConfirm([]);
  }, [onConfirm]);


  useImperativeHandle(ref, () => ({
    reset: handleReset,
  }));


  const onSelectAll = () => {
    const values = dataSourceAll?.map((item) => item?.value)

    if (!keywords) {
      if (isAll) {
        setSelected([])
        setIsAll(false)
      } else {
        setSelected(values)
        setIsAll(true)
      }

      return
    }

    if (isAll) {
      // 删除元素
      const newSelected = selected.filter((item) => !(searchList?.includes(item)))

      // console.log(newSelected)

      setSelected(newSelected)
      setIsAll(false)
    } else {
      // 添加元素
      const newSelected = Array.from(new Set([...selected, ...searchList]))

      // console.log(newSelected)

      setSelected(newSelected)
      setIsAll(true)
    }
  }

  const searchDebounce = useDebounce(async (...args: [string, number, boolean]) => {
    const keywords = args[0];
    if (!keywords) {
      if (selected.length === 0) {
        setSelected(dataSourceAll.map((item) => item?.value));
      }
      setSearchList([])
      return;
    }
    const res = dataSourceAll?.filter((item) => item?.value?.toUpperCase()?.includes(keywords?.toUpperCase()))?.map((item) => item?.value)

    setSearchList(res)

    let isAll = true;

    res?.forEach((item) => {
      if (!selected?.includes(item)) {
        isAll = false;
      }
    })

    setIsAll(isAll)
  }, 600);

  const handleSearch = useCallback((keywords?: string) => {
    const _keywords = keywords || '';
    setKeywords(_keywords);
    searchDebounce(_keywords, 1, false);
  }, [searchDebounce]);

  const handleClose = useCallback(() => {
    let payload = selected;
    if (!selected?.length) {
      setSelected(dataSourceAll.map((item) => item?.value));
      payload = dataSourceAll.map((item) => item?.value);
    }
    if (!keywords) {
      payload = !payload?.length || payload?.length === dataSourceAll?.length ? [] : payload;
    }
    onConfirm instanceof Function && onConfirm(payload);
  }, [keywords, selected, onConfirm])

  return (
    <>
      <SelectMultiple
        className={'select-item'}
        style={{ width: '270px' }}
        staging={false}
        searchValue={keywords}
        searchable
        listHeight={254}
        appearance="button"
        options={renderOptions()}
        onSearchValueChange={(keyword) => {
          setKeywords(keyword);
        }}
        onChange={handleChange}
        onSearch={handleSearch}
        onClose={handleClose}
        value={selected}
        button={
          <div className="dbi-select-button">
            <div className="select-button-text">{formatMessage({ id: 'dbi-sm-filter-datasource' })}</div>
            <div className="select-button-desc">
              {buttonLabel}
            </div>
          </div>
        }
        tips={
          <div className="dbi-selects-flex">
            <span className="dbi-selects-flex-lf">{formatMessage({ id: 'dbi-sm-filter-datasource' })}</span>
            <span className="dbi-selects-flex-rt"
              onClick={onSelectAll}
            >
              {!isAll ? 'Select All' : 'Clear All'}
            </span>
          </div>
        }
        matchButtonWidth
      />
    </>
  );
}

export default forwardRef(MetricsDataSourceAll);
